module.exports = __webpack_public_path__ + "static/media/send.2e3b6a1c.svg";